import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/business/crmCustomer/page',
    method: 'get',
    params
  })
}

export function noTagPage(params) {
  return request({
    url: '/api/business/crmCustomer/noTagPage',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/business/crmCustomer',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/business/crmCustomer',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/business/crmCustomer/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/business/crmCustomer',
    method: 'get',
    params: {
      id
    }
  })
}

export function saveIntegration(data) {
  return request({
    url: '/api/business/crmCustomer/saveIntegration',
    method: 'post',
    data
  })
}

export function updateIntegration(data) {
  return request({
    url: '/api/business/crmCustomer/updateIntegration',
    method: 'post',
    data
  })
}

export function getIntegrationInfo(data) {
  return request({
    url: '/api/business/crmCustomer/getIntegrationInfo',
    method: 'get',
    params: data
  })
}
export function getAllDataByCustomerType(data) {
  return request({
    url: '/api/business/crmCustomer/getAllDataByCustomerType',
    method: 'get',
    params: data
  })
}
export function listInfoById(customerIds) {
  return request({
    url: '/api/business/crmCustomer/listInfoById',
    method: 'get',
    params: {
      customerIds
    }
  })
}
export function settingDef(params) {
  return request({
    url: '/api/business/crmCustomer/settingDef',
    method: 'get',
    params
  })
}
